import managment_img from '@/public//industries/locksmith/Enhance Customer Communication.webp';
import app_img from '@/public/article/App.webp';
import gps_img from '@/public/article/GPS-Tracking.webp';
import article1 from '@/public/article/picture.webp';
import main_bg from '@/public/industries/locksmith/main.webp';
import schedule_img from '@/public/industries/locksmith/Optimize Your Workforce Management.webp';
import invoicing from '@/public/industries/locksmith/Tailor Your Offers to Maximize Revenue.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'Does My Locksmith Business Need Software?  ',
    text: 'Yes, locksmith software can greatly improve your business in terms of scheduling, dispatching, customers, and invoicing, and result in better outcomes and customer satisfaction.',
  },
  {
    title: 'Is Orcatec Locksmith Software Free?  ',
    text: `Orcatec offers a free starter package, allowing businesses to explore its features without any initial investment. Additional functionalities can be added as needed.`,
  },
  {
    title: 'Does Orcatec Have a Locksmith App? ',
    text: 'Yes, Orcatec has a mobile application running on both iOS and Android. The mobile app will allow the locksmith to track his operations remotely; therefore making the operations more flexible.',
  },
];

const testimonals = [
  {
    text: `I like the fact that Orcatec is very customizable; we were able to adapt the software to a locksmith service specifically for our own needs. With the further development of our business, customizability became indispensable. Their customer support is always with you, very helpful, so my overall impression is quite positive.`,
    name: 'Emma S., ',
    position: 'Owner, Elite Key Solutions',
  },

  {
    text: `The starter package being free from Orcatec enabled us to start up without really putting any up-front costs, which was very crucial to our startup. In other words, being able to add more features as our business grows has been just right for scaling up our operations.`,
    name: 'Derek M., ',
    position: 'Manager, Metro City Locksmith',
  },
  {
    text: `Using Orcatec has significantly decreased the time we spend on administrative tasks. The integrated call tracking and messaging system ensures we never miss a customer request and helps keep our service top-notch. It's a robust tool that every locksmith company should consider.`,
    name: 'Sophia N., ',
    position: 'Owner, Lock & Key Experts',
  },

  {
    text: `I like the fact that Orcatec is very customizable; we were able to adapt the software to a locksmith service specifically for our own needs. With the further development of our business, customizability became indispensable. Their customer support is always with you, very helpful, so my overall impression is quite positive.`,
    name: 'Emma S., ',
    position: 'Owner, Elite Key Solutions',
  },

  {
    text: `The starter package being free from Orcatec enabled us to start up without really putting any up-front costs, which was very crucial to our startup. In other words, being able to add more features as our business grows has been just right for scaling up our operations.`,
    name: 'Derek M., ',
    position: 'Manager, Metro City Locksmith',
  },
  {
    text: `Using Orcatec has significantly decreased the time we spend on administrative tasks. The integrated call tracking and messaging system ensures we never miss a customer request and helps keep our service top-notch. It's a robust tool that every locksmith company should consider.`,
    name: 'Sophia N., ',
    position: 'Owner, Lock & Key Experts',
  },
];

const industries = {
  title: 'Our Top Industries',
  description: `Orcatec offers industry-specific software solutions for a range of service-based businesses. Each software is tailored to meet the unique demands of its respective industry:
  `,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Locksmith Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Dispatching & Scheduling',
      },
      href: '#',
      tag: 'Dispatching & Scheduling',
      title: 'Optimize Your Workforce Management',
      text: `Orcatec’s dispatching and scheduling features streamline the assignment of work orders and ensure that the right personnel with the appropriate skills are dispatched. This optimization leads to better time management and increased job satisfaction among technicians.`,
      list: [
        {
          text: 'Match technicians to jobs based on their skill levels and availability.',
        },
        {
          text: 'Reduce manual entry errors and save time with automated scheduling tools.',
        },
        {
          text: 'Keep everyone informed with real-time updates to schedules and dispatches.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Call Tracking & Messaging',
      },
      href: '#',
      tag: 'Call Tracking & Messaging',
      title: 'Enhance Customer Communication',
      text: `Maintain a robust communication line with your clients using Orcatec's call tracking and messaging features. This functionality ensures that all interactions are logged and accessible, improving service and client satisfaction.`,
      list: [
        {
          text: 'Manage all calls and messages in one place.',
        },
        {
          text: 'Keep a comprehensive history of all client interactions, enhancing service personalization.',
        },
        {
          text: 'Set up automated messages for common inquiries to improve response times.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Sales Proposals ',
      },
      href: '#',
      tag: 'Sales Proposals',
      title: 'Tailor Your Offers to Maximize Revenue',
      text: `With Orcatec’s sales proposal tools, you can create detailed, tiered service options (Good, Better, Best) that cater to various customer needs and budgets. This feature not only enhances customer service but also significantly boosts potential revenue.`,

      list: [
        {
          text: 'Offer multiple service levels to meet diverse customer preferences.',
        },
        {
          text: 'Easily generate proposals during or after client interactions.',
        },
        {
          text: 'Improve sales conversion rates with attractive, professional proposals.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: gps_img,
        alt: 'GPS Tracking',
      },
      href: '#',
      tag: 'GPS Tracking',
      title: 'Monitor Your Field Operations',
      text: `Keep a close eye on your field technicians with Orcatec’s GPS tracking feature. This tool provides precise location data, enhancing dispatch efficiency and ensuring safety and accountability in the field.`,
      list: [
        {
          text: 'Know the location of your technicians all the time.',
        },
        {
          text: 'Ensure the best possible routes are taken to minimize the time used and consume less fuel.',
        },
        {
          text: 'Enhance technicians’ safety by monitoring their locations during working hours.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Locksmith Software',
  title: {
    first_part: 'Turn Your Locksmith Business Around with Our Cutting-Edge',
    second_part: 'Free Software',
  },
  description: `Our app allows a Locksmith to have a free and lovely experience. The user faces ease in scheduling, keeping track of the schedule, and managing clients. Be the best at what you do in the market with the right tools for efficiency and effectiveness.`,
  info: [
    { title: '30%', description: 'Increase in customer satisfaction' },
    { title: '50%', description: 'Reduce cost reduction' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What is Locksmith Business Software?',
  },
  title: 'What is Locksmith Business Software?',
  // eslint-disable-next-line no-irregular-whitespace
  description: `Locksmith management software provided by Orcatec is a comprehensive solution designed to streamline operations for locksmith companies. This software addresses key challenges such as scheduling, dispatching, and customer management, thereby enhancing efficiency and service quality.​`,
  item: [
    {
      title: '',
      description:
        'he software allows locksmith businesses to easily book and schedule services, ensuring efficient time management and preventing double bookings​.',
    },
    {
      title: '',
      description:
        'Orcatec helps with quick dispatch and real-time tracking of field personnel, optimizing route planning and reducing response times​.',
    },
    {
      title: '',
      description:
        'The system includes tools for maintaining detailed customer profiles, which helps in personalizing service and building stronger customer relationships​.',
    },
    {
      title: '',
      description:
        'ntegrated invoicing and mobile payment solutions facilitate smooth financial transactions, improving cash flow management​.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Do Locksmith Contractors Choose Orcatec?',
  },
  title: 'Why Do Locksmith Contractors Choose Orcatec?',
  description: `Locksmith contractors are coming to work with Orcatec more and more for their business management needs and for some very compelling reasons that will meet the demands of this fast-paced industry.`,
  item: [
    {
      title: '',
      description:
        'The free version of Orcatec enables a user to start off without an investment, thus reducing the barrier to small businesses and startups. The contractors are able to test the software, hence being able to confirm whether the software will be compatible with their operations or not before investing in them.',
    },
    {
      title: '',
      description:
        'That allows the user to select and pay for what he needs only, thus maximizing his expense for what he wants and not filling it with redundant functions. As a business grows, the features can seamlessly be built upon hence, Orcatec is more a long-term partner than just a software provider.',
    },
    {
      title: '',
      description: `The free locksmith business software can easily be modified to meet the unique requirements of each of the locksmith businesses, thereby ensuring that every little functionality aspect is tailored to the specific needs in operations. The customization will go further to cover workflows, user interfaces, and reports, bringing in user satisfaction and increased efficiency.`,
    },
    {
      title: '',
      description: `Orcatec is available on all PC, tablet, and mobile devices, where the user will be in charge even while on the move. Support for all leading platforms, from iOS to Android, means everyone in your team has access to it, no matter what device they prefer to work with.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `In our blog, we analyze the latest trends, offer recommendations for improving operational efficiency, and deliver guidance on making the most of your locksmith company software to advance your locksmith services.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `We at Orcatec serve various industries with tailor-made software solutions designed especially for your needs. We are committed to providing you with specialized tools to help you increase your efficiency and output, be it in locksmithing, plumbing, electrical work, or any other field service industry. Learn how our innovative software is transforming your business operation.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
